export default "__VITE_ASSET__CobbSQX5__"